module.exports = __webpack_public_path__ + "img/3DSis_checked.e7c6e6bf.png";